import React, { useMemo } from 'react';
import { LeftArrow, RightArrow } from './ChangerButton';

interface RoomsProps {
    presentation: any[];
    day: string;
    onRoomLeft?: () => void;
    onRoomRight?: () => void;
    currentRoomIndex?: number;
    isMobileOrTablet?: boolean;
}

const Rooms: React.FC<RoomsProps> = ({ presentation, day, onRoomLeft, onRoomRight, currentRoomIndex = 0, isMobileOrTablet = false }) => {

    const uniqueRooms = useMemo<string[]>(() => {
        try {
            const rooms = new Set<string>();
            presentation?.forEach(p => {
                if (p.room_info?.name && `Day ${p.day}` === day) {
                    rooms.add(p.room_info.name);
                }
            });
            return Array.from(rooms);
        } catch (error) {
            console.error("Error calculating unique rooms:", error);
            return [];
        }
    }, [presentation, day]);

    // Only show one room at a time on mobile/tablet
    const visibleRooms = isMobileOrTablet ? [uniqueRooms[currentRoomIndex]] : uniqueRooms;

    return (
        <>
            <div className="tw-w-full tw-flex tw-flex-row tw-items-start tw-text-sm tw-font-semibold tw-text-[#4B4F5A] lg:tw-p-3 lg:tw-mb-3 tw-gap-72">
                {visibleRooms.map((room, index) => (
                    <span
                        key={index}
                        className="tw-w-full tw-relative lg:tw-w-auto tw-flex tw-flex-row tw-items-center tw-justify-center tw-whitespace-nowrap tw-font-semibold tw-px-5 tw-py-5 lg:tw-py-1 lg:tw-rounded-full lg:tw-bg-customColor lg:tw-text-customColor2 tw-bg-white">
                        {isMobileOrTablet && (
                            <span className="tw-absolute tw-left-3 tw-top-5 -tw-translate-y-1/2 lg:tw-hidden" onClick={onRoomLeft} role="button" tabIndex={0}>
                                <LeftArrow color="#32363F" />
                            </span>
                        )}

                        {/* Centered Room Name */}
                        <span className="tw-text-center tw-font-semibold tw-text-[#32363F]">
                            {room}
                        </span>

                        {isMobileOrTablet && (
                            <span className="tw-absolute tw-right-3 tw-top-5 -tw-translate-y-1/2 lg:tw-hidden" onClick={onRoomRight} role="button" tabIndex={0}>
                                <RightArrow color="#32363F" />
                            </span>
                        )}
                    </span>
                ))}
            </div>
        </>
    );
}

export default Rooms;